import { render, staticRenderFns } from "./ConferenceType.vue?vue&type=template&id=54b1e0c8&"
import script from "./ConferenceType.vue?vue&type=script&lang=ts&"
export * from "./ConferenceType.vue?vue&type=script&lang=ts&"
import style0 from "./ConferenceType.vue?vue&type=style&index=0&id=54b1e0c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports